import logo from './images/logo2_transparant.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
          The Codanalyst
      </header>
    </div>
  );
}

export default App;
